// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.qt-designer-form {
    overflow: auto;
}

div.qt-designer-form textarea {
    height: 100%;
}

div.qt-designer-form div.text-input-wrapper,
div.qt-designer-form div.text-input-wrapper > pre {
    min-height: 2em;
}

div.qt-designer-form div.text-input-wrapper-multiline,
div.qt-designer-form div.text-input-wrapper-multiline > pre {
    height: 100%;
}

div.qt-designer-form div.TextInput,
div.qt-designer-form div.TextInput > pre {
    min-height: 2em;
}

div.qt-designer-form label > input {
    margin-right: 0.25em;
}

div.qt-designer-layout-grid {
    display: grid;
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    height: 100%;
}

div.qt-designer-layout-grid > div {
    display: flex;
    align-items: center;
}

div.qt-designer-layout-grid > div > *:not(.qt-designer-form-vline) {
    width: 100%;
}

div.qt-designer-layout-vbox {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
}

div.qt-designer-layout-hbox {
    display: flex;
    flex: 1 1 auto;
}

div.qt-designer-layout-hbox > div,
div.qt-designer-layout-vbox > div {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
}

div.qt-designer-form-hline {
    border-bottom: 1px solid var(--border-color);
}

div.qt-designer-form-vline {
    border-right: 1px solid var(--border-color);
    height: 100%;
}

div.qt-designer-form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

div.qt-designer-form-frame-title {
    font-weight: bold;
    flex: 0 0 auto;
}

div.qt-designer-form-frame {
    padding: 0.25em;
    flex: 1 1 auto;
    width: 100%;
    border: 1px solid var(--border-color);
}

div.qt-designer-form-tabbar {
    overflow-x: auto;
}

div.qt-designer-form-tabbar > span {
    padding: 0.25em;
    border-left: 1px solid var(--border-color);
    border-top: 1px solid var(--border-color);
    display: inline-block;
    background-color: var(--button-bg-color);
    height: 2em;
    display: inline-flex;
    align-items: center;
}

div.qt-designer-form-tabbar > span:last-child {
    border-right: 1px solid var(--border-color);
}

div.qt-designer-form-tabbar > span.qt-designer-form-tab-active {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

div.qt-designer-widget-relation {
    height: 100%;
    display: flex;
    flex-direction: column;
}

div.qt-designer-widget-relation-table-container {
    overflow-y: auto;
    flex: 1 1 auto;
    height: 4.5em;
    position: relative;
}

div.qt-designer-widget-relation-table-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(200, 200, 200, 0.9);
    z-index: 2;
}

div.qt-designer-widget-relation-table-loading > div.spinner {
    width: 4em;
    height: 4em;
}

div.qt-designer-widget-relation-table-container > table {
    width: 100%;
    border: 1px solid var(--border-color);
}

div.qt-designer-widget-relation-table-container > table td {
    padding: 0.25em 0.125em;
    text-align: center;
}

div.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-record-icon {
    width: 1px;
}
div.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-row-widget > * {
    width: 100%;
}

div.qt-designer-widget-relation-table-container > table td > label {
    display: block;
    text-align: center;
    white-space: nowrap;
}

div.qt-designer-widget-relation-table-container > table th {
    background-color: var(--border-color);
    color: white;
}

div.qt-designer-widget-relation-table-container > table tr:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
}

tr.qt-designer-widget-relation-record-deleted {
    background-color: rgb(255,127,127);
}

div.qt-designer-widget-relation-buttons {
    flex: 0 0 auto;
}

button.qt-designer-widget-relation-add {
    width: 100%;
}

div.qt-designer-form label {
    display: flex;
    align-items: center;
}

div.qt-designer-form-featurelink-buttons {
    display: flex;
}

div.qt-designer-form-featurelink-buttons > div.ButtonBar {
    flex: 1 1 auto;
}

div.qt-designer-form-featurelink-buttons > button.button {
    margin: 0.25em 0;
}

div.qt-designer-report {
    background-color: white;
}

div.qt-designer-report input,
div.qt-designer-report textarea,
div.qt-designer-report select {
    border: none!important;
    outline: none!important;
}

div.qt-designer-report select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

div.qt-designer-form-textarea {
    padding: 0.25em;
    white-space: pre-wrap;
}

div.qt-designer-form-image img {
    width: 100%;
    max-width: 400px;
}

div.qt-designer-form-loading {
    display: flex;
    align-items: center;
    justify-content: center;
}

div.qt-designer-form-loading > div.spinner {
    width: 4em;
    height: 4em;
    margin-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./../qwc2/components/style/QtDesignerForm.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,yCAAyC;IACzC,qBAAqB;IACrB,wCAAwC;IACxC,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB","sourcesContent":["div.qt-designer-form {\n    overflow: auto;\n}\n\ndiv.qt-designer-form textarea {\n    height: 100%;\n}\n\ndiv.qt-designer-form div.text-input-wrapper,\ndiv.qt-designer-form div.text-input-wrapper > pre {\n    min-height: 2em;\n}\n\ndiv.qt-designer-form div.text-input-wrapper-multiline,\ndiv.qt-designer-form div.text-input-wrapper-multiline > pre {\n    height: 100%;\n}\n\ndiv.qt-designer-form div.TextInput,\ndiv.qt-designer-form div.TextInput > pre {\n    min-height: 2em;\n}\n\ndiv.qt-designer-form label > input {\n    margin-right: 0.25em;\n}\n\ndiv.qt-designer-layout-grid {\n    display: grid;\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    height: 100%;\n}\n\ndiv.qt-designer-layout-grid > div {\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-layout-grid > div > *:not(.qt-designer-form-vline) {\n    width: 100%;\n}\n\ndiv.qt-designer-layout-vbox {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-layout-hbox {\n    display: flex;\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-layout-hbox > div,\ndiv.qt-designer-layout-vbox > div {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form-hline {\n    border-bottom: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-form-vline {\n    border-right: 1px solid var(--border-color);\n    height: 100%;\n}\n\ndiv.qt-designer-form-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.qt-designer-form-frame-title {\n    font-weight: bold;\n    flex: 0 0 auto;\n}\n\ndiv.qt-designer-form-frame {\n    padding: 0.25em;\n    flex: 1 1 auto;\n    width: 100%;\n    border: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-form-tabbar {\n    overflow-x: auto;\n}\n\ndiv.qt-designer-form-tabbar > span {\n    padding: 0.25em;\n    border-left: 1px solid var(--border-color);\n    border-top: 1px solid var(--border-color);\n    display: inline-block;\n    background-color: var(--button-bg-color);\n    height: 2em;\n    display: inline-flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form-tabbar > span:last-child {\n    border-right: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-form-tabbar > span.qt-designer-form-tab-active {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\ndiv.qt-designer-widget-relation {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.qt-designer-widget-relation-table-container {\n    overflow-y: auto;\n    flex: 1 1 auto;\n    height: 4.5em;\n    position: relative;\n}\n\ndiv.qt-designer-widget-relation-table-loading {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(200, 200, 200, 0.9);\n    z-index: 2;\n}\n\ndiv.qt-designer-widget-relation-table-loading > div.spinner {\n    width: 4em;\n    height: 4em;\n}\n\ndiv.qt-designer-widget-relation-table-container > table {\n    width: 100%;\n    border: 1px solid var(--border-color);\n}\n\ndiv.qt-designer-widget-relation-table-container > table td {\n    padding: 0.25em 0.125em;\n    text-align: center;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-record-icon {\n    width: 1px;\n}\ndiv.qt-designer-widget-relation-table-container > table td.qt-designer-widget-relation-row-widget > * {\n    width: 100%;\n}\n\ndiv.qt-designer-widget-relation-table-container > table td > label {\n    display: block;\n    text-align: center;\n    white-space: nowrap;\n}\n\ndiv.qt-designer-widget-relation-table-container > table th {\n    background-color: var(--border-color);\n    color: white;\n}\n\ndiv.qt-designer-widget-relation-table-container > table tr:not(:last-child) {\n    border-bottom: 1px solid var(--border-color);\n}\n\ntr.qt-designer-widget-relation-record-deleted {\n    background-color: rgb(255,127,127);\n}\n\ndiv.qt-designer-widget-relation-buttons {\n    flex: 0 0 auto;\n}\n\nbutton.qt-designer-widget-relation-add {\n    width: 100%;\n}\n\ndiv.qt-designer-form label {\n    display: flex;\n    align-items: center;\n}\n\ndiv.qt-designer-form-featurelink-buttons {\n    display: flex;\n}\n\ndiv.qt-designer-form-featurelink-buttons > div.ButtonBar {\n    flex: 1 1 auto;\n}\n\ndiv.qt-designer-form-featurelink-buttons > button.button {\n    margin: 0.25em 0;\n}\n\ndiv.qt-designer-report {\n    background-color: white;\n}\n\ndiv.qt-designer-report input,\ndiv.qt-designer-report textarea,\ndiv.qt-designer-report select {\n    border: none!important;\n    outline: none!important;\n}\n\ndiv.qt-designer-report select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\ndiv.qt-designer-form-textarea {\n    padding: 0.25em;\n    white-space: pre-wrap;\n}\n\ndiv.qt-designer-form-image img {\n    width: 100%;\n    max-width: 400px;\n}\n\ndiv.qt-designer-form-loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\ndiv.qt-designer-form-loading > div.spinner {\n    width: 4em;\n    height: 4em;\n    margin-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
